export default __webpack_public_path__ + "static/media/QS_Home.d65fb27d.png";